<template>
  <div class="w-100">
    <div class="w-100">
      <h4 class="text-center my-3 grey--text" style="font-weight: 300">
        {{ title.title }}
      </h4>

      <!-- تب‌های طبقات -->
      <v-tabs
        v-model="tab"
        class="rounded-xl custom-tabs"
        height="60"
        show-arrows
        grow
        scrollable
        dir="rtl"
      >
        <v-tab
          v-for="(floor, i) in shops.floors"
          :key="floor.id || i"
          :value="i"
          class="custom-tab"
        >
          <v-icon left small>mdi-floor-plan</v-icon>
          {{ floor.name }}
        </v-tab>
      </v-tabs>

      <!-- محتوای تب‌ها -->
      <v-tabs-items v-model="tab" class="tab-items" dir="rtl">
        <v-tab-item v-for="(floor, i) in shops.floors" :key="i">
          <div v-if="floor.items.length > 0">
            <!-- تب‌های خطوط در صورت نبودن فروشگاه -->
            <v-tabs
              v-model="tab2"
              class="custom-tabs mt-4"
              height="50"
              show-arrows
              grow
              scrollable
              dir="rtl"
            >
              <v-tab
                v-for="(line, j) in floor.items"
                :key="j"
                class="custom-tab"
              >
                <v-icon left small>mdi-storefront-outline</v-icon>
                {{ line.name }}
              </v-tab>
            </v-tabs>

            <!-- محتوای خطوط -->
            <v-tabs-items v-model="tab2">
              <v-tab-item v-for="(line, j) in floor.items" :key="j">
                <div class="shop-card text-center my-2 w-100">
                  <b-floor-shops
                    v-if="line.shops.length > 0"
                    v-model="line.shops"
                    :shops="shops.shops"
                  />
                  <span
                    v-else
                    class="text-center my-3 grey--text"
                    style="font-weight: 300"
                    >فروشگاهی در این لاین وجود ندارد</span
                  >
                </div>
              </v-tab-item>
            </v-tabs-items>
          </div>
          <div v-else class="shop-card my-2 text-center w-100">
            <b-floor-shops
              v-if="floor.shops.length > 0"
              v-model="floor.shops"
              :shops="shops.shops"
            />
            <span
              class="text-center my-3 grey--text"
              style="font-weight: 300"
              v-else
              >فروشگاهی در این طبقه وجود ندارد</span
            >
          </div>
        </v-tab-item>
      </v-tabs-items>
    </div>
  </div>
</template>

<script>
import bFloorShops from "../cm/bFloorShops.vue";

export default {
  name: "bShopFloors",
  components: { bFloorShops },
  props: {
    value: {
      type: Object,
      required: true,
    },
    title: Object,
  },
  data() {
    return {
      tab: 0,
      tab2: 0,
    };
  },
  computed: {
    shops() {
      return this.value;
    },
  },
};
</script>

<style scoped>
.text-title {
  font-size: 1.5rem;
  font-weight: bold;
  margin-bottom: 16px;
  color: #333;
}

.custom-tabs {
  background-color: #f4f4f4;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.custom-tab {
  transition: all 0.3s ease;
  font-weight: 500;
  color: #555;
  padding: 0 12px;
  min-width: 120px;
}

.custom-tab:hover {
  background-color: #e3f2fd;
  color: #1565c0;
}

.v-tab--active.custom-tab {
  background-color: #fff;
  color: #1976d2;
  font-weight: bold;
  border-bottom: 3px solid #1976d2;
}

.tab-items {
  margin-top: 20px;
}

.shop-card {
  background-color: #fff;
  /* padding: 20px; */
  border-radius: 12px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
  margin-top: 16px;

  width: 100%;
  max-width: 100%;
  overflow-x: hidden;
  box-sizing: border-box;
}
</style>
